module.exports = __webpack_public_path__ + "static/media/liquor_white.2ae09e2b.svg";